import React from 'react';
import CardMedia from '@material-ui/core/CardMedia';
import CardActionArea from '@material-ui/core/CardActionArea';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { withStyles }         from '@material-ui/core/styles';

    
  /*                           CLASES DE ESTILO                       */

  var styles = theme =>({
    Dialog:{
      borderRadius: 30,
      margin:0,
      padding:0
    },
})
/*                                        EXPORT                                      */
export default withStyles(styles)(
    class Pagina404 extends React.Component {
        constructor(props) {
            
            super(props);
            this.height=props.height
            this.movil_pequeño=props.movil_pequeño
  
            this.state = {
                isLoggin :          undefined,
            }
        }      
        
           /*                                          RENDER                          */
        render() {
                return (
                            <div style={{width: '100%',bottom:0,top: window.innerHeight-120,background: 'white'}}>
                              <Card style={{boxShadow: 'none'}}>
                                <CardActionArea>
                                <CardContent style={{background: 'white'}}>
                                    <div style={{width: '100%',textAlign: 'center', fontSize: '18px', color: 'red'}}>
                                        ¡¡  Página no encontrada  !!
                                    </div>
                                </CardContent>
                                <CardMedia
                                    image={'/Multimedia/404.webp'}
                                    title="Error 404"
                                    style={{width: '100%',boxShadow: 'none',height: window.innerHeight-190,backgroundSize: this.movil_pequeño?'90%':'50%'}}
                                />
                                </CardActionArea>
                              </Card>
                             </div>
                    )
        }
    }
)